import type { SVGProps } from "react";
export interface RadiationIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function RadiationIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: RadiationIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M15.116 14.928c.295.047.56.208.736.45l2.642 3.643c.485.668.403 1.639-.27 2.188l-.142.105a11.12 11.12 0 0 1-11.822.213l-.342-.213c-.8-.524-.93-1.58-.413-2.293l2.643-3.642.148-.166a1.125 1.125 0 0 1 1.425-.083c.64.467 1.427.742 2.28.742s1.638-.275 2.277-.742l.19-.112c.201-.093.427-.125.648-.09m-.488 2.596a6.1 6.1 0 0 1-5.258 0L7.733 19.78a8.87 8.87 0 0 0 4.268 1.096 8.86 8.86 0 0 0 4.264-1.096zM7.134 1.976a1.61 1.61 0 0 1 1.956.714l.075.146 1.83 4.12a1.125 1.125 0 0 1-.57 1.484 3.88 3.88 0 0 0-2.28 3.954 1.125 1.125 0 0 1-1 1.233l-4.476.472c-.878.092-1.725-.55-1.778-1.504a11.15 11.15 0 0 1 1.474-6.179l.21-.347a11.13 11.13 0 0 1 4.397-4.021zm7.776.714c.379-.661 1.198-1.002 1.957-.714l.16.072.358.189a11.15 11.15 0 0 1 5.738 9.954l-.015.404c-.052.954-.9 1.595-1.778 1.503l-4.475-.47a1.125 1.125 0 0 1-1-1.234 3.885 3.885 0 0 0-2.28-3.954 1.125 1.125 0 0 1-.571-1.483l1.832-4.121zM7.39 4.389a8.9 8.9 0 0 0-2.909 2.874l-.167.277a8.9 8.9 0 0 0-1.188 4.248l2.769-.293a6.13 6.13 0 0 1 2.63-4.553L7.392 4.389Zm8.082 2.553a6.12 6.12 0 0 1 2.631 4.553l2.769.293a8.9 8.9 0 0 0-1.03-3.966l-.157-.282a8.9 8.9 0 0 0-3.078-3.153zm-3.255 2.945a2.126 2.126 0 1 1-2.332 2.332l-.01-.217.01-.218a2.127 2.127 0 0 1 2.116-1.909z"
      />
    </svg>
  );
}
